/**
 * 跨分頁的登入/登出事件廣播
 *
 * 用獨立的 BroadcastChannel 只傳事件名稱（'login' / 'logout'），不傳 state。
 * 收到事件後讓各分頁自己跑 useLogout({eraseOnly}) / useMemberAsync()，
 * 避免 pinia-shared-state 在 state 層 echo 造成 logout 被舊狀態覆蓋的問題。
 */
const CHANNEL_NAME = 'ug-session-event'

export type SessionBroadcastEvent = 'login' | 'logout'

let channel: BroadcastChannel | null = null

function getChannel(): BroadcastChannel | null {
  if (!import.meta.client) return null
  if (typeof BroadcastChannel === 'undefined') return null
  if (!channel) channel = new BroadcastChannel(CHANNEL_NAME)
  return channel
}

export function broadcastSessionEvent(event: SessionBroadcastEvent) {
  const ch = getChannel()
  if (!ch) return
  ch.postMessage({ event, ts: Date.now() })
}

export function listenSessionEvent(handler: (event: SessionBroadcastEvent) => void) {
  const ch = getChannel()
  if (!ch) return () => {}
  const fn = (evt: MessageEvent) => {
    if (evt.data && (evt.data.event === 'login' || evt.data.event === 'logout')) {
      handler(evt.data.event)
    }
  }
  ch.addEventListener('message', fn)
  return () => ch.removeEventListener('message', fn)
}
